/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 网盘素材
  FileResources: () => import(/* webpackChunkName: "FileResources" */ '@/views/page/FileResources/index')
};

export const FileResourcesRoute = [
  {
    path: '/FileResources',
    isMenu: true,
    component: Layout,
    redirect: { name: 'FileResources' },
    children: [
      {
        path: 'index',
        name: 'FileResources',
        component: routes['FileResources'],
        meta: { title: '网盘素材管理', icon: 'menu_guanwanguanli'}
      }
    ]
  }
];
